import Service from "../Service";
const resource = "PrfClosePallet/";

export default {
    list(parameters, requestID) {
        return Service.post(resource + "list", parameters, {
            params: { requestID: requestID },
        });
    },

    closePallet(parameters, requestID) {
        return Service.post(resource + "closePallet", parameters, {
            params: { requestID: requestID },
        });
    },
};